import { ref, reactive, computed, watch } from 'vue';
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-e7b74c9c"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "discount-plan-content"
};
const _hoisted_2 = {
  class: "plan-title-content"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "plan-title"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "line"
}), /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "优惠方案")], -1));
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "删除优惠", -1));
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "停用优惠", -1));
const _hoisted_6 = [_hoisted_5];
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "启用优惠", -1));
const _hoisted_8 = [_hoisted_7];
const _hoisted_9 = {
  key: 0,
  class: "discount-empty-content"
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "desc"
}, "如需为订阅商品设置促销价格，请添加优惠方案", -1));
const _hoisted_11 = {
  key: 1,
  class: "discount-form-content"
};
import { Modal, message } from 'ant-design-vue';
import SelectModal from '@/components/SelectModal.vue';
import PriceShowBlock from '@/views/goodsManage/goodsSetting/components/PriceShowBlock.vue';
import { getNode } from '@/common';
export default /*#__PURE__*/_defineComponent({
  __name: 'DiscountPlan',
  props: {
    readOnly: {
      type: Boolean
    },
    detail: null,
    priceArr: null
  },
  setup(__props, {
    expose
  }) {
    const props = __props;
    const durationUnitList = [{
      label: '天',
      value: 'D'
    }, {
      label: '周',
      value: 'W'
    }, {
      label: '月',
      value: 'M'
    }, {
      label: '年',
      value: 'Y'
    }];
    const typeList = [{
      label: '免费试用，订阅者在指定期限内无需付费',
      value: '0'
    }];
    const isEmpty = ref(true);
    const discountForm = reactive({
      regionConfigList: [],
      qualifications: ['0', '0'],
      type: '0',
      time: 3,
      period: 'D',
      status: '1'
    });
    const qualificationsList = ref([{
      value: '0',
      label: '新用户获取(首次订阅的用户)',
      desc: '首次订阅的客户',
      children: [{
        value: '0',
        label: '从未订阅过此内容'
      }, {
        value: '10',
        label: '从未订阅过任何内容'
      }]
    }]);
    const visible = ref(false);
    const discountRef = ref(null);
    const allList = ref([]);
    const addDiscount = () => {
      isEmpty.value = false;
    };
    const deleteDiscount = () => {
      Modal.confirm({
        title: '删除优惠',
        content: '删除此优惠后，创建的优惠信息将全部清除，是否确认删除？',
        centered: true,
        okText: '确认',
        cancelText: '取消',
        onOk() {
          isEmpty.value = true;
        }
      });
    };
    const showCountryModal = () => {
      visible.value = true;
    };
    const saveCountry = value => {
      discountForm.regionConfigList = value;
    };
    const handleData = () => {
      var _discountForm$regionC;
      if (isEmpty.value) return null;
      return {
        regionConfigList: (_discountForm$regionC = discountForm.regionConfigList) === null || _discountForm$regionC === void 0 ? void 0 : _discountForm$regionC.map(item => {
          return {
            regionCode: item
          };
        }),
        regionTargeting: {
          targeting: discountForm.qualifications[0],
          targetingRuleScope: discountForm.qualifications[1]
        },
        type: discountForm.type,
        duration: {
          time: discountForm.time,
          period: discountForm.period
        },
        productNativePrice: props.priceArr.filter(item => discountForm.regionConfigList.includes(item.regionCode)).map(item => {
          item['discountType'] = '0';
          return item;
        }),
        status: discountForm.status
      };
    };
    const checkOut = () => {
      if (isEmpty.value) return true;
      discountRef.value.validate();
      if (!discountForm.time) {
        message.error('优惠时长信息需要填写完整');
        return false;
      }
      return !!discountForm.regionConfigList.length;
    };
    const deactivateDiscount = () => {
      Modal.confirm({
        title: '停用优惠',
        content: '停用此优惠后，优惠方案将在商品审核通过后失效，是否确认停用？',
        centered: true,
        okText: '确认',
        cancelText: '取消',
        onOk() {
          discountForm.status = '0';
        }
      });
    };
    const startUsingDiscount = () => {
      Modal.confirm({
        title: '启用优惠',
        content: '启用此优惠后，优惠方案将在商品审核通过后生效，是否确认启用？',
        centered: true,
        okText: '确认',
        cancelText: '取消',
        onOk() {
          discountForm.status = '1';
        }
      });
    };
    const changeTimeType = () => {
      discountForm.time = 3;
    };
    const maxNumber = computed(() => {
      switch (discountForm.period) {
        case 'D':
          return 365;
        case 'W':
          return 52;
        case 'M':
          return 12;
        case 'Y':
          return 3;
        default:
          return 365;
      }
    });
    const minNumber = computed(() => {
      switch (discountForm.period) {
        case 'D':
          return 3;
        default:
          return 1;
      }
    });
    watch(() => props.priceArr, n => {
      var _discountForm$regionC2;
      allList.value = n === null || n === void 0 ? void 0 : n.map(item => {
        return {
          value: item.regionCode,
          label: item.regionName
        };
      });
      if (!((_discountForm$regionC2 = discountForm.regionConfigList) !== null && _discountForm$regionC2 !== void 0 && _discountForm$regionC2.length)) discountForm.regionConfigList = n === null || n === void 0 ? void 0 : n.map(item => item.regionCode);
    }, {
      immediate: true
    });
    watch(() => props.detail, n => {
      if (n !== null && n !== void 0 && n.prodGracePlan) {
        var _n$prodGracePlan, _n$prodGracePlan2, _n$prodGracePlan3, _n$prodGracePlan4, _n$prodGracePlan5, _n$prodGracePlan6, _n$prodGracePlan7;
        isEmpty.value = false;
        discountForm.regionConfigList = (n === null || n === void 0 || (_n$prodGracePlan = n.prodGracePlan) === null || _n$prodGracePlan === void 0 || (_n$prodGracePlan = _n$prodGracePlan.regionConfigList) === null || _n$prodGracePlan === void 0 ? void 0 : _n$prodGracePlan.map(item => item.regionCode)) || [];
        discountForm.qualifications = [n === null || n === void 0 || (_n$prodGracePlan2 = n.prodGracePlan) === null || _n$prodGracePlan2 === void 0 || (_n$prodGracePlan2 = _n$prodGracePlan2.regionTargeting) === null || _n$prodGracePlan2 === void 0 ? void 0 : _n$prodGracePlan2.targeting, n === null || n === void 0 || (_n$prodGracePlan3 = n.prodGracePlan) === null || _n$prodGracePlan3 === void 0 || (_n$prodGracePlan3 = _n$prodGracePlan3.regionTargeting) === null || _n$prodGracePlan3 === void 0 ? void 0 : _n$prodGracePlan3.targetingRuleScope];
        discountForm.type = n === null || n === void 0 || (_n$prodGracePlan4 = n.prodGracePlan) === null || _n$prodGracePlan4 === void 0 ? void 0 : _n$prodGracePlan4.type;
        discountForm.time = n === null || n === void 0 || (_n$prodGracePlan5 = n.prodGracePlan) === null || _n$prodGracePlan5 === void 0 || (_n$prodGracePlan5 = _n$prodGracePlan5.duration) === null || _n$prodGracePlan5 === void 0 ? void 0 : _n$prodGracePlan5.time;
        discountForm.period = n === null || n === void 0 || (_n$prodGracePlan6 = n.prodGracePlan) === null || _n$prodGracePlan6 === void 0 || (_n$prodGracePlan6 = _n$prodGracePlan6.duration) === null || _n$prodGracePlan6 === void 0 ? void 0 : _n$prodGracePlan6.period;
        discountForm.status = n === null || n === void 0 || (_n$prodGracePlan7 = n.prodGracePlan) === null || _n$prodGracePlan7 === void 0 ? void 0 : _n$prodGracePlan7.status;
      }
    }, {
      immediate: true
    });
    expose({
      checkOut,
      handleData,
      isEmpty
    });
    return (_ctx, _cache) => {
      const _component_svg_icon = _resolveComponent("svg-icon");
      const _component_a_form_item = _resolveComponent("a-form-item");
      const _component_a_cascader = _resolveComponent("a-cascader");
      const _component_a_select = _resolveComponent("a-select");
      const _component_a_input_number = _resolveComponent("a-input-number");
      const _component_a_form = _resolveComponent("a-form");
      const _component_a_divider = _resolveComponent("a-divider");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, !isEmpty.value && !__props.readOnly && __props.detail.publishStatus !== 10 && !__props.detail.replicaStatus && !__props.detail.replicaStatus ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "delete-content",
        onClick: deleteDiscount
      }, [_createVNode(_component_svg_icon, {
        "icon-class": "delete",
        "class-name": "delete-icon"
      }), _hoisted_4])) : _createCommentVNode("", true), !isEmpty.value && !__props.readOnly && __props.detail.prodStatus === 10 && (__props.detail.publishStatus === 10 || __props.detail.replicaStatus) && (discountForm === null || discountForm === void 0 ? void 0 : discountForm.status) === '1' ? (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: "delete-content",
        onClick: deactivateDiscount
      }, _hoisted_6)) : _createCommentVNode("", true), !isEmpty.value && !__props.readOnly && __props.detail.prodStatus === 10 && (__props.detail.publishStatus === 10 || __props.detail.replicaStatus) && (discountForm === null || discountForm === void 0 ? void 0 : discountForm.status) === '0' ? (_openBlock(), _createElementBlock("div", {
        key: 2,
        class: "delete-content",
        onClick: startUsingDiscount
      }, _hoisted_8)) : _createCommentVNode("", true)]), isEmpty.value ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_createVNode(_component_svg_icon, {
        "icon-class": "discountEmpty",
        "class-name": "empty-icon"
      }), _hoisted_10, _createElementVNode("div", {
        class: "add-btn",
        onClick: addDiscount
      }, "添加")])) : (_openBlock(), _createElementBlock("div", _hoisted_11, [_createVNode(_component_a_form, {
        name: "discount-form",
        model: discountForm,
        ref_key: "discountRef",
        ref: discountRef
      }, {
        default: _withCtx(() => [_createVNode(_component_a_form_item, {
          label: "适用范围",
          required: "",
          name: "regionConfigList"
        }, {
          default: _withCtx(() => [_createElementVNode("span", {
            class: "choose-country",
            onClick: showCountryModal
          }, "选择参与优惠的国家/地区")]),
          _: 1
        }), _createVNode(_component_a_form_item, {
          label: "资格条件",
          required: "",
          name: "qualifications"
        }, {
          default: _withCtx(() => [_createVNode(_component_a_cascader, {
            options: qualificationsList.value,
            value: discountForm.qualifications,
            "onUpdate:value": _cache[0] || (_cache[0] = $event => discountForm.qualifications = $event),
            disabled: __props.readOnly || discountForm.status === '0',
            "allow-clear": false,
            getPopupContainer: _unref(getNode)
          }, null, 8, ["options", "value", "disabled", "getPopupContainer"])]),
          _: 1
        }), _createVNode(_component_a_form_item, {
          label: "优惠类型",
          required: "",
          name: "type"
        }, {
          default: _withCtx(() => [_createVNode(_component_a_select, {
            value: discountForm.type,
            "onUpdate:value": _cache[1] || (_cache[1] = $event => discountForm.type = $event),
            disabled: __props.readOnly || discountForm.status === '0',
            options: typeList,
            getPopupContainer: _unref(getNode)
          }, null, 8, ["value", "disabled", "getPopupContainer"])]),
          _: 1
        }), _createVNode(_component_a_form_item, {
          label: "优惠时长",
          required: ""
        }, {
          default: _withCtx(() => [_createVNode(_component_a_input_number, {
            precision: 0,
            class: "small",
            value: discountForm.time,
            "onUpdate:value": _cache[2] || (_cache[2] = $event => discountForm.time = $event),
            max: _unref(maxNumber),
            min: _unref(minNumber),
            disabled: __props.readOnly || discountForm.status === '0'
          }, null, 8, ["value", "max", "min", "disabled"]), _createVNode(_component_a_select, {
            class: "small",
            options: durationUnitList,
            value: discountForm.period,
            "onUpdate:value": _cache[3] || (_cache[3] = $event => discountForm.period = $event),
            disabled: __props.readOnly || discountForm.status === '0',
            onChange: changeTimeType,
            getPopupContainer: _unref(getNode)
          }, null, 8, ["value", "disabled", "getPopupContainer"])]),
          _: 1
        }), _createVNode(_component_a_form_item, {
          label: "本地价格"
        }, {
          default: _withCtx(() => [_createVNode(PriceShowBlock, {
            "price-list": __props.priceArr,
            "selected-country": discountForm.regionConfigList
          }, null, 8, ["price-list", "selected-country"])]),
          _: 1
        })]),
        _: 1
      }, 8, ["model"]), _createVNode(_component_a_divider, {
        style: {
          "margin": "0"
        }
      })])), _createVNode(SelectModal, {
        "read-only": __props.readOnly || discountForm.status === '0',
        "model-visible": visible.value,
        "onUpdate:model-visible": _cache[4] || (_cache[4] = $event => visible.value = $event),
        title: "选择国家/地区",
        "all-list": allList.value,
        onSaveData: saveCountry,
        "edit-item": discountForm === null || discountForm === void 0 ? void 0 : discountForm.regionConfigList
      }, null, 8, ["read-only", "model-visible", "all-list", "edit-item"])]);
    };
  }
});